import Model from "./base/model";

class Notification extends Model{
  resourceName() {
    return "notifications";
  }

  fields() {
    return {
      name: "",
      description: "",
      group: "",
      system: "",
      email: "",
      permissions: "",
      following_order: "",
      active_by_default: "",
    }
  }
}

export default new Notification();
